require('url-search-params-polyfill');
const EditorJS = require('@editorjs/editorjs');

const db = firebase.database();
var pagesData = {};
var isCo = false;
var isEdit = false;
var ui = new firebaseui.auth.AuthUI(firebase.auth());

/*
SLD 0 => width: 470px;left: 453px;top: 180px;
"<div class='terCt'><figure class='imgCnt' id='terreImg'><div class='svg' id='svglighten' data-url='img/fltTerre.svg'></div><img style='filter: url(\"#svglightenFlt\");' src='img/Terre.png'/><h6></figure><h4 class='t0'>Les thérapies brèves</h4><h4 class='t1'>L'hypnose</h4><h4 class='t3'>la pleine conscience</h4><h4 class='t4'>L'approche systémique</h4><h4 class='t5'>Les TCC</h4><h4 class='t6'>Le courant humaniste et existentiel</h4></div>"
*/

window.addEventListener('load', function() {
    window.page = 'accueil';
    let urlPrm = new URLSearchParams(location.search);
    console.log(urlPrm);
    if (urlPrm.get('edit')) {
        if (urlPrm.get('edit') === '1') isEdit = true;
    }
    if (urlPrm.get('p')) {
        window.page = urlPrm.get('p');
    }

    actPage()
    let pT = [
        ['accueil', 'ACCUEIL'],
        ['demarche', 'MA DEMARCHE'],
        [
            'consultation', 
            'CONSULTATIONS', 
            [
                ['enfants', 'ENFANTS'],
                ['adolescents', 'ADOLESCENTS'],
                ['adultes', 'ADULTES'],
                ['sportifs', 'SPORTIFS']
            ]
        ],
        ['parcours', 'MON PARCOURS'],
        ['contact', 'CONTACT']
    ];
    
    for (pNav of pT) {
        let clLi = '';
        if (pNav[0] == window.page) {
            clLi = 'liAct';
        }
        let subUl = '';
        let aNavElm = document.createElement('li');
        if (pNav[2]) {
            if (window.outerWidth >= 980) {
                aNavElm.classList.add('hasSub');
                subUl = '<div class="subUl sub' + pNav[0] + '"><ul>';
                for (cNav of pNav[2]) {
                    subUl += "<a href='?p=" + cNav[0] + "'><li>" + cNav[1] + "</li></a>";
                }
                subUl += '</ul></div>';
            }
            //document.querySelector('header nav').insertAdjacentHTML('beforeend', subUl);
        }
        aNavElm.innerHTML = "<a href='?p=" + pNav[0] + "' data-lnk='" + pNav[0] + "' class='" + clLi + "'>" + pNav[1] + "</a>" + subUl;
        document.querySelector('nav>ul').insertAdjacentElement('beforeend', aNavElm);
    }
    var dN = new Date();
    document.querySelector('.dateYear').innerHTML = dN.getFullYear();

    document.querySelector('nav>ul').addEventListener('mouseover', function(e) {
        if (e.target.parentNode.matches('.hasSub')) {
            document.querySelector('.subUl').style.display = 'block';
        }
    });
    if (document.getElementsByClassName('subUl').length > 0) {
        document.querySelector('.subUl').addEventListener('mouseover', function(e) {
            document.querySelector('.subUl').style.display = 'block';
        });
        document.querySelector('nav>ul').addEventListener('mouseout', function(e) {
            document.querySelectorAll('.subUl').forEach(function(subElm) {
                subElm.style.display = 'none';
            })
        });
    }
    
    db.ref('/pages').once('value').then(function(snapshot) {
        pagesData = snapshot.val();
        actContent()
            .then(() => {
                console.log('firstLoad');
                console.log('isCo', isCo)
                console.log('isEdit', isEdit)
            })
    });
})

function initMap() {
    var posSrc = {lat: 47.3842098, lng: 0.6739479};
    var map = new google.maps.Map(document.getElementById('map'), {zoom: 14, center: posSrc});
    var marker = new google.maps.Marker({position: posSrc, map: map});
    var posSrc2 = {lat: 47.4327697, lng: 0.6676036};
    var map2 = new google.maps.Map(document.getElementById('map2'), {zoom: 14, center: posSrc2});
    var marker2 = new google.maps.Marker({position: posSrc2, map: map2});
}

function actPage() {
    switch (window.page) {
        case 'enfants':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/enfantBg.png)';
            document.getElementById('bgCt').style.backgroundSize = '100% auto';
            document.getElementById('bgCt').style.opacity = 0.7;
        break;
        case 'adolescents':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/adoBg.png)';
            document.getElementById('bgCt').style.backgroundSize = '100% auto';
            document.getElementById('bgCt').style.opacity = 0.7;
        break;
        case 'adultes':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/adulteBg.png)';
            document.getElementById('bgCt').style.backgroundSize = 'auto 100%';
            document.getElementById('bgCt').style.opacity = 0.5;
        break;
        case 'sportifs':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/sportBg.png)';
            document.getElementById('bgCt').style.backgroundSize = '100% auto';
            document.getElementById('bgCt').style.opacity = 0.5;
        break;
        case 'demarche':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/demBg.png)';
            document.getElementById('bgCt').style.backgroundSize = '100% auto';
            document.getElementById('bgCt').style.opacity = 0.7;
        break;
        case 'consultation':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/demBg.png)';
            document.getElementById('bgCt').style.backgroundSize = '100% auto';
            document.getElementById('bgCt').style.opacity = 0.7;
        break;
        case 'parcours':
            document.getElementById('bgCt').style.backgroundImage = 'url(img/parcBg.png)';
            document.getElementById('bgCt').style.backgroundSize = '100% auto';
            document.getElementById('bgCt').style.opacity = 0.7;
        break;
        default:
            document.getElementById('bgCt').style.backgroundImage = 'url(img/bg.png)';
            document.getElementById('bgCt').style.backgroundSize = 'auto 100%';
            document.getElementById('bgCt').style.opacity = 0.7;
        break;
    }
    document.title = window.page;
}

function actContent() {
    return new Promise((resolve, reject) => {
        if (firebase.auth().currentUser) {
            isCo = true;
        } 
        console.log('isCo', isCo)
        console.log('isEdit', isEdit)
        if (isEdit && !isCo) {
            ui.start('#firebaseui-auth-container', {
                signInOptions: [ 
                    firebase.auth.EmailAuthProvider.PROVIDER_ID
                ],
                signInFlow: 'popup',
                signInSuccessUrl : '/'
            });
        }
        fetchContent(pagesData)
        .then(function() {
            if (document.getElementById('map')) initMap()
            if (document.getElementById('slider') && document.getElementsByClassName('sld').length > 0) {
                let lSld = document.querySelector('.sld:last-child');
                lSldCp = lSld.cloneNode(true);
                document.querySelector('.flgCt').insertAdjacentElement('afterbegin', lSldCp);
                lSld.parentNode.removeChild(lSld);

                setInterval(() => {
                    console.log("sldAuto")
                    let fSld = document.querySelector('.sld:first-child');
                    fSldCp = fSld.cloneNode(true);
                    document.querySelector('.flgCt').insertAdjacentElement('beforeend', fSldCp);
                    fSld.parentNode.removeChild(fSld);    
                    let actElm = document.querySelector('.sld.active');
                    actElm.classList.remove('active');
                    actElm.nextSibling.classList.add('active');
                }, 8500)

                document.querySelector('#flD').addEventListener('click', () => {
                    let fSld = document.querySelector('.sld:first-child');
                    fSldCp = fSld.cloneNode(true);
                    document.querySelector('.flgCt').insertAdjacentElement('beforeend', fSldCp);
                    fSld.parentNode.removeChild(fSld);    
                    let actElm = document.querySelector('.sld.active');
                    actElm.classList.remove('active');
                    actElm.nextSibling.classList.add('active');
                })
                
                document.querySelector('#flG').addEventListener('click', () => {
                    let lSld = document.querySelector('.sld:last-child');
                    lSldCp = lSld.cloneNode(true);
                    document.querySelector('.flgCt').insertAdjacentElement('afterbegin', lSldCp);
                    lSld.parentNode.removeChild(lSld);    
                    let actElm = document.querySelector('.sld.active');
                    actElm.classList.remove('active');
                    actElm.previousSibling.classList.add('active');
                })
            }

            if (document.getElementById('contForm')) {
                document.getElementById('contForm').addEventListener('submit', (e) => {
                    e.preventDefault();
                    let valPrm = new URLSearchParams({
                        msg: document.querySelector('#contForm .msg').value,
                        dest: document.querySelector('#contForm .dest').value,
                        name: document.querySelector('#contForm .name').value
                    })
                    fetch(document.getElementById('contForm').getAttribute('data-action') + '?' + valPrm.toString())
                        .then(function (response) {
                            if (response.status === 200) {
                                document.querySelector('#contForm .msg').value = ''
                                document.querySelector('#contForm .dest').value = ''
                                document.querySelector('#contForm .name').value = ''
                                document.querySelector('.sendedMsg').style.display = 'block'
                            }
                        })
                })
            }
        
            document.querySelectorAll('a').forEach(function(aElm) {
                if (!aElm.getAttribute('hasListener')) {
                    aElm.setAttribute('hasListener', true)
                    aElm.addEventListener('click', function(e) {
                        if ((aElm.href.indexOf('doc/') === -1) && (aElm.href.substr(0,16) === location.href.substr(0,16))) {
                            e.preventDefault();
                            window.page = aElm.href.split('=')[1];
                            actPage()
                            window.scroll(0, 0);
                            actContent()
                        }
                    })
                }
            })
            resolve()
        })
    })
}

function fetchContent(data) {
    return new Promise(function(resolve, reject) {
        if (!document.querySelectorAll('.content[data-page="' + window.page + '"]').length) {
            let contElm = "<div class='content' data-page='" + window.page + "'>";
            for (pData of data[window.page]) {
                switch (pData.type) {
                    case 'tiH3': 
                        contElm += '<div class="tiCt"><img src="img/tiLogo.svg" class="tiImg"/><h3 class="editBlc tiElm">' + pData.content + '</h3></div>';
                    break;
                    case 'tiH4': 
                        contElm += '<div class="tiCt"><img src="img/tiLogo.svg" class="tiImg"/><h4 class="editBlc tiElm">' + pData.content + '</h3></div>';
                    break;
                    case 'pCont':
                        contElm += '<div class="editBlc pCont">' + pData.content + '</div>';
                    break;
                    case 'pContS':
                        contElm += '<div class="editBlc pCont pContS">' + pData.content + '</div>';
                    break;
                    case 'pContS2':
                        contElm += '<div class="editBlc pCont pContS2">' + pData.content + '</div>';
                    break;
                    case 'pContS3':
                        contElm += '<div class="editBlc pCont pContS2">' + pData.content + '</div>';
                    break;
                    default: 
                        contElm += pData.content;
                    break;
                }
            }
            contElm += '<div class="clB"></div></div>';
            document.getElementById('contentCt').insertAdjacentHTML('beforeend', contElm);
            loadSvg();
        }
        if (isCo) addEdit()   
        document.querySelectorAll('.content').forEach((contE) => contE.classList.remove('pageAct'))
        document.querySelector('.content[data-page="' + window.page + '"]').classList.add('pageAct')
        resolve(true);
    })
}

var svgT = {};

function loadSvg() {
    document.querySelectorAll('.svg').forEach(function(svgElm) {
        let svgUrl = svgElm.getAttribute('data-url');
        if (svgT[svgUrl]) {
            svgElm.innerHTML =  svgT[svgUrl];
        }
        else {
            fetch(svgUrl)
                .then(response => response.text())
                .then(svg => {
                    svgElm.innerHTML =  svg;
                    svgT[svgUrl] = svg;
                });
        }
    })
}

var editorT = [];
// 'Marck Script', 'Damion', 'Futura-LT-W01-Light', 'din-next-w01-light', 'din-next-w02-light', 'din-next-w10-light', 'Mr De Haviland', 'Suez One'

// nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons',

function addEdit() {
    editorT = [];
    tinymce.init({
        selector: '.editBlc',
        plugins: 'code link lists', 
        menubar: 'file edit view',
        toolbar: 'undo redo | code | bold italic underline strikethrough | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | outdent indent | bullist | forecolor backcolor removeformat | link',
        font_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats; Din Light=din-next-w01-light, din-next-w02-light, din-next-w10-light, sans-serif;',
        setup: function (editor) {
            editor.on('init', function () {
                editorT.push(editor.id);
            });
        } 
    });
    if (!document.querySelector('#contentCt .editE')) {
        document.querySelector('#contentCt').insertAdjacentHTML('beforeend', '<button class="editE">Enregistrer</button>')
    
        var edBtn = document.querySelector('#contentCt .editE')
        edBtn.addEventListener('click', (e) => {
            console.log(editorT)
            console.log(edBtn.innerHTML)
            if (edBtn.innerHTML == 'Editer') {
                edBtn.innerHTML = 'Enregistrer'
                for(let ed of editorT) {
                    tinymce.get(ed).show();
                }
            }
            else {
                edBtn.innerHTML = 'Editer'
                let pageV = [];
                for(let ed of editorT) {
                    let edI = tinymce.get(ed);
                    tinymce.get(ed).hide();
                    let trgElm = edI.targetElm
                    if (trgElm.classList.contains('tiElm')) {
                        pageV.push({
                            "type": 'ti' + trgElm.nodeName,
                            "content": trgElm.innerText
                        })
                    }
                    if (trgElm.classList.contains('pCont')) {
                        let tyP = 'pCont';
                        if (trgElm.classList.contains('pContS')) {
                            tyP = 'pContS'
                        }
                        if (trgElm.classList.contains('pContS2')) {
                            tyP = 'pContS2'
                        }
                        if (trgElm.classList.contains('pContS3')) {
                            tyP = 'pContS3'
                        }
                        pageV.push({
                            "type": tyP,
                            "content": edI.getContent()
                        })
                    }
                }
                let pageVT = Object.values(pageV);
                Object.values(pagesData[window.page]).map((contV, i) => {
                    if (contV.type != 'html') {
                        pagesData[window.page][i].content = pageVT[0].content
                        pageVT = pageVT.slice(1)
                    }
                })
                firebase.database().ref('pages/' + window.page).set(pagesData[window.page]);
            }
        })
    }
    else {
        document.querySelector('#contentCt .editE').innerHTML = 'Enregistrer';
    }
}